import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Subhead02Text } from '../../../../components/typography/typography';
import { CoverageItemStyles } from './coverage-item-style';

type CoverageCardProps = {
  coverage: string;
};

const CoverageItem = ({ coverage }: CoverageCardProps) => {
  return (
    <CoverageItemStyles data-cy="survey-card">
      <div className="coverage-item__header">
        <div className="coverage-item__icon">
          <FontAwesomeIcon icon={['fas', 'shield-halved']} />
        </div>
        <div className="coverage-item__main">
          <Subhead02Text weight={600}>{coverage}</Subhead02Text>
        </div>
      </div>
    </CoverageItemStyles>
  );
};

export default CoverageItem;
